import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_RECENT_PRODUCTS_HANDLER = {
  topic: TOPIC_NAMES.OPEN_RECENT_PRODUCTS,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/RecentProducts')
};